<template>
    <div class="flex flex-col items-center justify-center gap-2 px-4 py-12 text-center">
        <icon icon="cil-clipboard" class="text-gray-light" size="xl" />
        <p class="text-sm text-gray-text">{{ message || trans('external.board.empty') }}</p>
    </div>
</template>

<script setup>
import { trans } from '@/mixins/i18n.js';

defineProps({
    message: {
        type: String,
        default: null,
    },
});
</script>
